// extracted by mini-css-extract-plugin
export default {"component":"b2CWGY","openIcon":"c2CWGY","columnTitle":"d2CWGY","column":"e2CWGY","columnItem":"f2CWGY","active":"g2CWGY"};